import { __ } from '~/locale';

export const USER_POPOVER_DELAY = 200;
export const I18N_ERROR_FOLLOW = __(
  'An error occurred while trying to follow this user, please try again.',
);
export const I18N_ERROR_UNFOLLOW = __(
  'An error occurred while trying to unfollow this user, please try again.',
);
export const I18N_USER_BLOCKED = __('User is blocked');
export const I18N_USER_BUSY = __('Busy');
export const I18N_USER_LEARN = __('Learn more about %{name}');
export const I18N_USER_FOLLOW = __('Follow');
export const I18N_USER_UNFOLLOW = __('Unfollow');
